// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main_layout[data-v-6e35be62]{height:100vh;width:100vw;display:flex}.main_layout .main_content[data-v-6e35be62]{flex:1;display:flex;flex-direction:column;min-width:400px}.main_layout .main_content .header_nav[data-v-6e35be62]{height:53px}.main_layout .main_content .content_box[data-v-6e35be62]{flex:1;overflow:auto}", ""]);
// Exports
module.exports = exports;
